export const createPlaceholderArray = (size: number): number[] => {
  return Array.from({ length: size }).map((v, i) => i)
}
